import { render, staticRenderFns } from "./KanjiSheet.vue?vue&type=template&id=2122581b&scoped=true"
import script from "./KanjiSheet.vue?vue&type=script&lang=js"
export * from "./KanjiSheet.vue?vue&type=script&lang=js"
import style0 from "./KanjiSheet.vue?vue&type=style&index=0&id=2122581b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2122581b",
  null
  
)

export default component.exports